<template>
    <div class="Service">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>MY<span> SERVICE</span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="Item flexa">
            <div class="List flexa">
                <span
                  v-for="(item, index) in itemlist"
                  :key="index"
                  :class="{ Active: index + 1 == stateindex }"  @click="GetProductList(item.state, index + 1)">
                  {{ item.state }}
                </span>
            </div>
  <!--          <div class="List flexa"><span class="Active">按时间</span><span>按金额</span><span>按产品</span></div>-->
        </div>
        <div class="OrderDetailWrap" v-if="detailstate">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p v-if="OrderDetailsData.定制 === '0'">产品续费</p><p v-else>服务续费</p></div>
                <div class="Return flexa" @click="CloseDetail"><p>返回</p><img src="../../assets/Home/return.png"></div>
            </div>
            <div class="PayforWrap">
                <!-- 内容 -->
                <div class="OrderContentWrap">
                    <div class="ProductInfo">
                        <i class="Pic"><img :src="OrderDetailsData.logo图"/></i>
                        <div class="Name">
                            <p>{{ OrderDetailsData.产品名称 }}</p>
                        </div>
                        <div class="Time">
                            <p>{{ OrderDetailsData.产品类型 }}</p>
                        </div>
                        <div class="Intro">
                            <p>
                                {{ OrderDetailsData.详情介绍 }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 钱数 -->
                <div class="MoneyCount">
                    <div
                            class="Title flexa"
                            v-if="OrderDetailsData.定制 === '0'"
                    >
                        <p style="width: 50%;text-align: left;margin-right: 0">
                            基础功能
                        </p>
                        <p style="width:49%;margin-right: 0;text-align: right;color:#d5b338">
                            ￥{{ OrderDetailsData.基础费用 }}/用户/年
                        </p>
                    </div>
                    <div v-if="OrderDetailsData.定制 === '0'">
                        <p
                                style="width: 100%;margin: 0.1rem auto;text-align: left;opacity: 0.8"
                        >
                            {{ OrderDetailsData.基础功能介绍 }}
                        </p>
                    </div>
                    <div style="width: 100%"  v-if="OrderDetailsData.可选功能">
                    <div class="Title flexa" >附加功能</div>
                    <div
                            class="flexbetween"
                            v-for="(item, index) in OrderDetailsData.可选功能.split(',')"
                            :key="index"
                            style="margin-top: 0.05rem"
                    >
                        <p style="width: 37.5%;margin-right: 0;color:  #d5b338"> </p>
                        <p style="width: 61.5%;margin-right: 0;">
                            {{ item }}
                        </p>
                    </div>
                    <div   class="flexbetween" style="margin-top: 0.05rem"><p style="width: 37.5%;margin-right: 0;color:  #d5b338"> </p><p style="color:  #d5b338;margin-right: 0;">￥{{ OrderDetailsData.可选功能费用 }}</p></div>
                    </div>
                    <div class="Title flexa"   v-if="OrderDetailsData.开发者姓名">开发者</div>
                    <div   v-if="OrderDetailsData.开发者姓名"><p style="width: 100%;margin-top: 0.05rem">{{ OrderDetailsData.开发者姓名 }}</p></div>
                    <div   v-if="OrderDetailsData.开发者姓名" class="Title flexa">定制项目</div>
                    <div   v-if="OrderDetailsData.开发者姓名"><p style="width: 100%;margin-top: 0.05rem">{{ OrderDetailsData.用户产品管理 }}</p></div>
                    <div class="Title flexa">订单金额</div>
                    <div class="PriceCount1">
                        <div style="width: 100%;" v-if="OrderDetailsData.定制 === '0'">
                            <div  v-if="OrderDetailsData.截止日期" class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                                <div style="width: 61%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        用户数 {{ OrderDetailsData.用户数量 }}
                                    </p>
                                </div>
                                <div style="width: 39%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        有效期至 {{ OrderDetailsData.截止日期 }}
                                    </p>
                                </div>
                            </div>
                            <div v-else  class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                                <div style="width: 61%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        用户数 {{ OrderDetailsData.用户数量 }}
                                    </p>
                                </div>
                                <div style="width: 39%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        有效期1年
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%;" v-else>
                            <div  class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                                <div style="width: 61%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">

                                    </p>
                                </div>
                                <div style="width: 39%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        有效期至 {{ OrderDetailsData.有效期 }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style="text-align: right;width: 100%;margin-top: 0.1rem">
                            <span style="font-size: 0.065rem;color: #fff;margin-right: 0.1rem">总金额</span>
                            <span style="font-size:0.075rem;color: #d5b338;"
                            >￥{{ OrderDetailsData.支付金额 }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部汇总 -->
            <div class="Foot">
                <div class="ButtonWrap clearfix">
                    <div class="flex Yes" @click="Payfor"><span>去支付</span></div>
                </div>
            </div>
        </div>
        <div class="AddInvoice flex" v-if="czstate">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="Closecz"><img src="../../assets/returns.png"/></i>
                    <p>创建系统</p>
                </header>
                <div class="DeveloperWrap">
                    <div>
                        <div class="InputWrap">
                            <div class="flexbetween">
              <span class="flex">企业名称</span
              >
                                <el-select v-model="zcuser" placeholder=""  @change="onSelect">
                                    <el-option
                                            v-for="item in actions"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="flexbetween">
              <span class="flex">邮箱</span
              ><input style="user-select: auto" v-model="zcemail" />
                            </div>
                            <div class="flexbetween">
              <span class="flex">联系人</span
              ><input style="user-select: auto" v-model="zccn" />
                            </div>
                            <div class="flexbetween">
              <span class="flex">联系方式</span
              ><input style="user-select: auto" v-model="zcphone" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="SubmitCreate" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">提交</div></div>
            </div>
        </div>
        <div class="ContentListWrap">
            <ul>
                <!-- 使用中样式 -->
                <li v-for="(item, index) in Product_ListData" :key="index">
                    <div class="C">
                    <div class="Name">
                        <p>{{ item.状态 }}</p>
                        <p>{{ item.名称 }}</p>
                    </div>
                    <div class="Time">
                       <div class="Top clearfix">
                           <p>有效期 <span>{{ item.有效期 }}</span></p>
                           <p>初次购买 <span>{{ item.初次购买时间 }}</span></p>
                       </div>
<!--                        <div class="Bottom clearfix">
                            <p>初次购买 <span>2020-09-20</span></p>
                            <p>授权单位 <span>单位名称</span></p>
                        </div>-->
                    </div>
                    <div class="ButtonWrap flexbetween">
                        <div class="Type flexa">
                            <div class="flex color1"><p>{{ item.订单类型 }}</p></div>
                        </div>
                        <div class="Next flexj">
                           <!-- <div class="flex color2"><p>升级</p></div>-->
                            <div class="flex color5"   v-if="item.是否创建 === '1' && item.状态 === '创建'" @click="OpenCreateSystem(item.订单编号,item.用户应用ID,item.云产品ID)"><p>创建系统</p></div>
                            <div class="flex color2"   v-if="item.是否创建 === '0' && item.状态 === '创建'"><p>系统创建中</p></div>
                            <div class="flex color5"   v-if="item.状态 === '使用' || item.状态 === '超期'"  @click="OpenDetail(item.订单编号)"><p>续费</p></div>
                        </div>
                    </div>
                    </div>
                    <div    v-if="item.servelist.length > 0">
                    <div class="flex" style="width: 94%;margin:0.1rem auto 0;font-size: 0.051rem;color: #fff;height: 0.2rem;border-top: 1px solid #fff">定制服务</div>
                    <div class="C1" v-for="(_item,index) in item.servelist" :key="index">
                        <div class="Name">
                            <p>服务名称</p>
                            <p>{{ _item.名称 }}</p>
                        </div>
                        <div class="Name" style="padding-top: 0.05rem">
                            <p>开发者</p>
                            <p>{{ _item.开发者 }}</p>
                        </div>
                        <div class="Time">
                            <div class="Top clearfix">
                                <p>有效期 <span>{{ _item.有效期 }}</span></p>
                                <p>初次购买 <span>{{ _item.初次购买时间 }}</span></p>
                            </div>
                        </div>
                        <div class="ButtonWrap flexbetween">
                            <div class="Next flexj">
                                <!-- <div class="flex color2"><p>升级</p></div>-->
                                <div class="flex color1" v-if="_item.状态==='使用'"><p>{{ _item.状态 }}</p></div>
                                <div v-else class="flex color4"   @click="OpenDetail(_item.订单编号)"><p>{{ _item.状态 }}</p></div>
                            </div>
                        </div>
                    </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="buystate">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请支付...</p></div>
                    <div class="CloseBox" @click="closepay('Web_WechatOrderQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div v-if="!payss">
                        <div class="CodeWrap">
                            <!--   <img :src="code">-->
                            <img :src="code">
                        </div>
                        <div class="flex Tip"><p>请使用微信扫描二维码支付</p></div>
                        <div class="flex ReButton" @click="Check('Web_WechatOrderQuery')">支付成功后点击这里刷新</div>
                    </div>
                    <div v-else class="flex" style="width: 100%;height:70%">
                        <i   @click="SubmitOrderData('M0042510000000000000000002')"  style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/al.png"></i>
                        <i   @click="SubmitOrderData('M0042510000000000000000001')" style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/wx.png"></i>
                    </div>
                    <div v-if="payss" class="flex ReButton" style="cursor: auto">请选择支付方式</div>
                </div>
            </div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="alstate">
            <div class="Login">
                <div class="LoginContentWrap" style="width: 1.8rem;height: 1.5rem">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 正在支付中...</p></div>
                    <div class="CloseBox" @click="closepay('Web_AlipayTradeQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div style="margin-top: 0.4rem">
                        <div class="flex Tip"><p>支付完成前请不要关闭此验证窗口</p></div>
                        <div class="flex ReButton" @click="Check('Web_AlipayTradeQuery')">支付成功后点击这里刷新</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  // eslint-disable-next-line no-unused-vars
  import { mapActions, mapGetters } from 'vuex';
  export default {
    inject: [
      'load'
    ],
    data() {
      return {
        buystate: false,
        name: '',
        payss: true,
        alstate: false,
        code: '',
        actions: [],
        stateindex: 1,
        state: '',
        zcuser: '',
        czstate: false,
        zccode: '',
        zcname: '',
        typeid: '',
        userid: '',
        productid: '',
        Cdata: [],
        zcphone: '',
        zccn: '',
        addzc: false,
        zcemail: '',
        zcstate: false,
        type: '',
        money: 0,
        PayforState: false,
        detailstate: false,
        ProductListData: [],
        Product_ListData: [],
        chooseperson: true,
        isIos: false,
        lastmoney: 0,
        orderid: '',
        orderNumber: '',
        OrderDetailsData: {},
        itemlist: [
          {
            state: '创建'
          },
          {
            state: '使用'
          },
          {
            state: '超期'
          },
          {
            state: '终止'
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo', 'currentSystem'])
    },
    created() {
      if (this.$route.params.orderstate && this.$route.params.index) {
        this.GetProductList(
          this.$route.params.orderstate,
          this.$route.params.index
        );
      } else {
        this.GetProductList(
          '创建',
          '1'
        );
      }
    },
    methods: {
      Check(param) {
        this.load.show();
        this.$utils.CheckPayfor(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId, param).then(res => {
          console.log(res);
          this.load.hide();
          if (res.data.code === 0) {
            this.$confirm('支付成功！请前往“个人中心-注册平台”进行企业注册！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '返回',
              closeOnClickModal: false,
              showClose: false,
              type: 'success'
            }).then(() => {
              this.$router.push({
                name: 'PersonCenter'
              });
            }).catch(() => {
              this.buystate = false;
              this.payss = true;
              this.detailstate = false;
              this.GetProductList(
                '创建',
                '1'
              );
            });
          } else {
            this.$confirm('您还没有支付成功！是否继续支付？', '提示', {
              confirmButtonText: '确定',
              closeOnClickModal: false,
              showClose: false,
              type: 'error'
            }).then(() => {
              console.log('未支付');
            }).catch(() => {
              this.$confirm('"您已取消支付!请尽快到个人中心我的订单-待支付中完成支付"', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push({
                  name: 'Order',
                  params: { orderstate: '待支付', index: 1 }
                });
              }).catch(() => {
                console.log('取消');
                this.buystate = false;
                this.payss = true;
                this.alstate = false;
              });
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message.error(error);
        });
      },
      closepay(param) {
        this.Check(param);
      },
      /* 支付前提交支付信息平台(选取支付平台最终支付调用) */
      SubmitOrderData(num) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007010',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: this.orderNumber,
            headData: {
              支付平台: num
            },
            saveGridData: 1
            /*   gridData: this.chooseitems */
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              if (num === 'M0042510000000000000000007') {
                /* 苹果支付 */
              } else if (num === 'M0042510000000000000000002') {
                /* 支付宝 */
                this.$utils.AliPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.alstate = true;
                  this.buystate = false;
                  window.open(res.data.data, '_blank');
                  // eslint-disable-next-line no-useless-escape
                  console.log(res.data);
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              } else {
                /* 微信 */
                this.$utils.WXPay_Web(this.orderNumber, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.payss = false;
                  this.alstate = false;
                  console.log(res);
                  this.code = res.data.data;
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              }
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 提交续费申请 */
      CreateOrder() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007022',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            headData: {
              订单编号: this.OrderDetailsData.订单编号,
              定制: this.OrderDetailsData.定制,
              用户应用ID: this.OrderDetailsData.用户应用ID,
              用户编码: this.LoginUserInfo.goeasyid,
              用户服务ID: this.OrderDetailsData.用户服务ID
            },
            saveGridData: 1
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.load.hide();
              this.orderNumber = res.data.data.orderNumber;
              this.buystate = true;
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      Payfor() {
        this.CreateOrder();
      },
      CloseDetail() {
        this.detailstate = false;
      },
      /* 获取续费页面信息 */
      GetContinueData(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007021',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 订单编号: id }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              this.OrderDetailsData = res.data.data.DETAIL[0];
              console.log(res);
              this.detailstate = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenDetail(id) {
        this.GetContinueData(id);
      },
      SubmitCreate() {
        if (this.zcphone && this.zccn && this.zcemail && this.type) {
          this.load.show();
          this.$axios({
            method: 'POST',
            url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
            data: {
              commandId: 'WBA0007044',
              buttonText: 'Verify',
              userId: 'GoeasyUser' + this.LoginUserInfo.userId,
              headData: {
                用户ID: this.LoginUserInfo.goeasyid,
                用户应用ID: this.userid,
                云产品ID: this.productid,
                企业信息: this.typeid,
                联系人: this.zccn,
                联系方式: this.zcphone,
                邮箱: this.zcemail,
                订单编号: this.orderid
              },
              saveGridData: 1
            }
          })
            .then(res => {
              this.load.hide();
              if (res.data.code === 0) {
                console.log(res);
                this.$message.success('提交成功！');
                this.Closecz();
                this.GetProductList(
                  this.$route.params.orderstate,
                  this.$route.params.index
                );
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(error => {
              this.load.hide();
              this.$message.error(error);
            });
        } else {
          this.$message.error('请确认所有信息已填写完毕');
        }
      },
      onSelect(item) {
        this.type = item;
        for (let i in this.Cdata) {
          if (this.Cdata[i].名称 === item) {
            this.zcphone = this.Cdata[i].联系方式;
            this.zccn = this.Cdata[i].联系人;
            this.zcemail = this.Cdata[i].邮箱;
            this.typeid = this.Cdata[i].企业ID;
          }
        }
      },
      Closecz() {
        this.czstate = false;
        this.type = '';
        this.zccn = '';
        this.zcphone = '';
        this.zcuser = '';
        this.zcemail = '';
        this.actions = [];
      },
      /* 获取注册企业列表 */
      GetZcCompneyList() {
        this.actions = [];
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007043',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.Cdata = res.data.data.DETAIL;
              for (let i in res.data.data.DETAIL) {
                let obg = {};
                obg.name = res.data.data.DETAIL[i].名称;
                this.actions.push(obg);
              }
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
      },
      OpenCreateSystem(data, id, pid) {
        this.czstate = true;
        this.orderid = data;
        this.userid = id;
        this.productid = pid;
        this.GetZcCompneyList();
      },
      /* 获取服务 */
      GetServeList() {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007039',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 状态: '' }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              /* 组合产品与服务 */
              console.log('服务列表:', res);
              for (let i in this.ProductListData) {
                this.ProductListData[i].servelist = [];
              }
              for (let i in this.ProductListData) {
                for (let j in res.data.data.DETAIL) {
                  if (
                    this.ProductListData[i].用户应用ID ===
                    res.data.data.DETAIL[j].用户应用ID
                  ) {
                    this.ProductListData[i].servelist.push(
                      res.data.data.DETAIL[j]
                    );
                  }
                }
              }
              this.Product_ListData = this.ProductListData;
              this.load.hide();
              console.log('整理完的数据:', this.Product_ListData);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            console.log(error);
            this.$message.error(error);
          });
      },
      /* 获取产品 */
      GetProductList(state, index) {
        this.load.show();
        this.stateindex = index;
        this.state = state;
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007017',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 状态: state }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log('产品列表:', res);
              this.GetServeList(state);
              this.ProductListData = res.data.data.DETAIL;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            console.log(error);
            this.$message.error(error);
          });
      },
      Return() {
        this.$router.back();
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
    .Service{
        .BuyBox{
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 4;
            .Login {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.6);
                z-index: 4;
                display: flex;
                -webkit-justify-content: center;
                -webkit-align-items: center;
                .LoginContentWrap {
                    width: 2.7rem;
                    height: 2.78rem;
                    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
                    background: linear-gradient(to bottom right, #6666cc, #4141b3);
                    position: relative;
                    .CloseBox {
                        width: 0.15rem;
                        height: 0.15rem;
                        position: absolute;
                        cursor: pointer;
                        right: 0.05rem;
                        top: 0.05rem;
                        z-index: 4;

                        img {
                            width: 100%;
                        }
                    }
                    .NeedKnown {
                        position: absolute;
                        width: 100%;
                        bottom: 0.1rem;

                        p {
                            font-size: $SmallTextSize;
                            color: #fff;
                            text-align: center;

                            span {
                                cursor: pointer;
                                font-weight: bold;
                                margin: 0 0.02rem;
                                color: #999900;
                            }
                        }
                    }
                    .LoginTitle {
                        width: 100%;
                        margin-top: 0.05rem;

                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-indent: 0.05rem;
                        }
                    }
                }
            }
            .ReButton{
                width: 1.3rem;
                height: 0.2rem;
                background-color: #9797ff;
                color: #fff;
                font-size: $TextSize;
                margin: 0.3rem auto 0;
                border-radius: 0.2rem;
                cursor: pointer;
            }
            .CodeWrap{
                width: 1.3rem;
                height: 1.3rem;
                background-color: #fff;
                margin: 0.3rem auto 0.1rem;
                border: 0.02rem solid #fff;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .Tip{
                width: 100%;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin: 0 0.03rem;
                }
                p:last-child{
                    font-size: $TextSize;
                    font-weight: bold;
                    color: #ceceff;
                }
            }
        }
        .OrderDetailWrap{
            .Foot {
                width: 100%;
                height: 0.6rem;
                .ButtonWrap {
                    width: 90%;
                    margin: 0 auto;
                    position: relative;
                    div:last-child {
                        margin-left: 0 !important;
                    }
                    .Yes,
                    .No {
                        width: 0.8rem;
                        height: 0.25rem;
                        float: right;
                        margin-left: 0.1rem;
                        background-color: #26a2ff;
                        border-radius: 0.8rem;
                        cursor: pointer;
                        span {
                            font-size: $TextSize;
                            color: #fff;
                        }
                    }
                    .Yes {
                        background-color: #8c73b5;
                    }
                    .No {
                        background-color: #666666;
                    }
                }
                .Count {
                    width: 6.3rem;
                    height: 0.8rem;
                    margin: 0 auto;
                    p {
                        font-size: 0.32rem;
                        text-align: right;
                        font-weight: bold;
                        color: #666666;
                    }
                }
            }
            .PayforWrap {
                width: 90%;
                margin: 0 auto;
                .ChooseComp {
                    width: 100%;
                    padding: 0.2rem 0;
                    ul {
                        width: 100%;
                        overflow-x: scroll;
                        overflow-scrolling: touch;
                        height: 1rem;
                        text-align: left;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        white-space: nowrap;
                        overflow-y: hidden;
                        li {
                            width: 1rem;
                            height: 0.3rem;
                            background-color: #666666;
                            display: inline-block;
                            margin-right: 0.02rem;
                            border-radius: 0.03rem;
                            div {
                                width: 100%;
                                height: 100%;
                            }
                            p {
                                font-size: $TextSize;
                                color: #fff;
                            }
                        }
                        li.Active {
                            background-color: #8c73b5;
                        }
                    }
                }
                .MoneyCount {
                    width:100%;
                    margin: 0.05rem auto 0;
                    padding-bottom: 0.1rem;
                    .Times {
                        width: 98%;
                        margin: 0.02rem auto;
                        div {
                            font-size: $AdditionTextSize;
                            width: 1rem;
                            float: left;
                            margin-bottom: 0.04rem;
                            input {
                                width: 0.1rem;
                                height: 0.1rem;
                                border-radius: 0.1rem;
                                margin-right: 0.05rem;
                            }
                        }
                    }
                    .TypeChooseWrap {
                        width: 100%;
                        .Types,
                        .TypesMore {
                            width: 0.8rem;
                            height: 0.5rem;
                            margin-right: 0.04rem;
                            border-radius: 0.08rem;
                            cursor: pointer;
                            background-color: #dee7eb;
                            float: left;
                            .Choosed {
                                box-sizing: border-box;
                                .Money {
                                    width: 90%;
                                    margin:0 auto;
                                    p {
                                        width: 94%;
                                        text-align: right;
                                        font-size: $SmallTitleSize;
                                        color: #626262;
                                        font-weight: bold;
                                    }
                                }
                                .Number {
                                    width: 90%;
                                    margin: 0.05rem auto 0.08rem;
                                    p {
                                        font-size: $SmallTitleSize;
                                        font-weight: bold;
                                        width: 100%;
                                        text-align: left;
                                    }
                                }
                                p {
                                    font-size: $AdditionTextSize;
                                    color: #414141;
                                }
                                input {
                                    width: 0.1rem;
                                    height: 0.1rem;
                                    border-radius: 0.04rem;
                                    margin: 0.05rem 0 0 0.05rem;
                                }
                            }
                        }
                        > div:nth-child(4n) {
                            margin-right: 0;
                        }
                    }
                    .Title {
                        width: 100%;
                        height: 0.15rem;
                        font-size: $TextSize;
                        color: #fff;
                        border-bottom: 1px solid #c9c9c9;
                    }
                    div {
                        width: 98%;
                        margin: 0 auto;
                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-align: right;
                            width: 40%;
                            margin-right: 0.1rem;
                        }
                        p:first-child {
                            width: 58%;
                        }
                    }
                }
                &::-webkit-scrollbar {
                    display: none;
                }
                .OrderContentWrap {
                    width:100%;
                    margin: 0 auto;
                    .ProductInfo {
                        width: 100%;
                        margin: 0 auto;
                        padding-bottom: 0.05rem;
                        padding-top: 0.05rem;
                        position: relative;
                        .Name {
                            margin-top: 0.05rem;
                            p {
                                font-size: $SmallTitleSize;
                                font-weight: bold;
                                color: #fff;
                            }
                        }
                        .Time {
                            margin-top: 0.05rem;
                            p {
                                font-size: $SmallTextSize;
                                color: #fff;
                                opacity: 0.8;
                            }
                        }
                        .Intro {
                            margin-top: 0.05rem;
                            p {
                                font-size: $TextSize;
                                color: #fff;
                                line-height: 0.1rem;
                            }
                        }
                        .Pic {
                            width: 0.4rem;
                            height: 0.4rem;
                            border-radius: 0.1rem;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 0.1rem;
                            }
                        }
                    }
                }
                .Step {
                    width: 100%;
                    .StepList {
                        width: 100%;
                        margin-bottom: 0.1rem;
                        .Time {
                            width: 0.4rem;
                            p {
                                font-size: $TextSize;
                                text-align: left;
                            }
                        }
                        .Text {
                            width: 2.5rem;
                            .TextContent {
                                margin-left: 0.08rem;
                                width: calc(100% - 0.08rem - 10px);
                                p {
                                    font-size: $TextSize;
                                    color: #666666;
                                    font-weight: bold;
                                }
                            }
                            i {
                                width: 10px;
                                height: 10px;
                                background-color: #bb4b47;
                                border-radius: 10px;
                                margin-top: 0.02rem;
                            }
                        }
                    }
                }
                .NumberWrap {
                    width: 100%;
                    p {
                        font-size: $TextSize;
                        color: #414141;
                    }
                }
            }
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 2;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .AddInvoice{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.6);
            position: absolute;
            left: 0;
            top: 0;
            z-index: 5;
            .InputWrap {
                width: 86%;
                margin: 0.1rem auto 0;
                ::v-deep .el-input__inner,.el-select{
                    width: 1.5rem;
                    border-radius: 0.05rem;
                    background-color: #f5f5f5;
                    padding: 0;
                    color: #414141;
                    height: 0.18rem;
                    font-size: 0.051rem;
                }
                ::v-deep .el-input__inner{
                    text-indent: 0.08rem;
                    border: none;
                }
                ::v-deep .el-select{
                    margin-bottom: 0;
                }
                div{
                    width: 100%;
                    margin-bottom: 0.1rem;
                    span {
                        font-size: $TextSize;
                        color: #414141;
                    }
                    input {
                        width: 1.5rem;
                        height: 0.18rem;
                        color: #414141;
                        background-color: #f5f5f5;
                        font-size: $TextSize;
                        text-indent: 0.08rem;
                        border-radius: 0.05rem;
                    }
                    input::placeholder{
                        font-size: $TextSize;
                    }
                }
                .tip {
                    margin-bottom: 0.08rem;
                    span {
                        font-size: $SmallTextSize;
                        color: rgba(65, 65, 65, 0.8);
                    }
                }
            }
            .DeveloperWrap {
                width: 100%;
                height: calc(100% - 0.7rem);
                overflow: scroll;
                overflow-scrolling: touch;
                margin-top: 0.05rem;
                &::-webkit-scrollbar {
                    display: none;
                }
                ul {
                    width: 100%;
                    padding-bottom: 0.2rem;
                    li{
                        width: 86%;
                        margin: 0.05rem auto;
                        background: linear-gradient(to Right, #333333, #1b1b1b);
                        overflow: auto;
                        padding: 0.08rem 0;
                        border-radius: 0.05rem;
                        p{
                            color: #fff;
                            margin-left: 0.1rem;
                        }
                        p:first-child{
                            font-size: $TitleSize;
                            margin-top: 0.02rem;
                        }
                        p:nth-child(2){
                            font-size: $TextSize;
                            margin: 0.1rem 0 0.02rem 0.1rem;
                        }
                        p:last-child{
                            font-size: $SmallTitleSize;
                        }
                    }
                }
            }
            .AddWrap{
                width: 30%;
                height: calc(100% - 1rem);
                background-color: #fff;
                border-radius: 0.1rem;
                header {
                    width: 88%;
                    height: 0.2rem;
                    margin: 0 auto;
                    padding-top: 0.1rem;
                    position: relative;
                    i {
                        width: 0.1rem;
                        cursor: pointer;
                        img {
                            width: 100%;
                        }
                    }
                    p {
                        font-size: $SmallTitleSize;
                        color: #666666;
                        position: absolute;
                        right: 0;
                        font-weight: bold;
                    }
                }
            }
        }
        width: 100%;
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .Item{
            width: 90%;
            margin: 0.05rem auto 0.1rem;
            .List{
                span{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    opacity: 0.7;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }
                span.Active{
                    opacity: 1;
                    font-weight: bold;
                }
            }
/*            .List:last-child{
                span{
                    margin-left: 0.1rem;
                    margin-right: 0;
                }
            }*/
        }
        .ContentListWrap{
            width: 90%;
            margin: 0.1rem auto;
            ul{
                width: 100%;
                li{
                    width: 100%;
                    border: 1px solid #fff;
                    border-radius: 0.08rem;
                    margin-bottom: 0.1rem;
                    padding: 0.04rem 0;
                    position: relative;
                    .C1{
                        width: 100%;
                        position: relative;
                        background: linear-gradient(to Right, #333333, #1b1b1b);
                        margin-bottom: 0.1rem;
                        padding-bottom: 0.1rem;
                        .ButtonWrap{
                            width: 0.4rem !important;
                            position: absolute;
                            right: 0.1rem;
                            bottom: 0.1rem;
                            .Next{
                                div{
                                    margin-left: 0 !important;
                                }
                            }
                        }
                    }
                    .color1{
                        background-color: #339933;
                    }
                    .color2{
                        background-color: #0066cc;
                    }
                    .color3{
                        background-color: #666666;
                    }
                    .color4{
                        background-color: #990000;
                    }
                    .color5{
                        background-color: #d5b338;
                    }
                    .ButtonWrap{
                        width: calc(100% - 0.2rem);
                        margin-left: 0.1rem;
                        margin-top: 0.05rem;
                        .Next{
                            div{
                                width: 0.4rem;
                                height: 0.15rem;
                                border-radius: 0.2rem;
                                margin-left: 0.1rem;
                                cursor: pointer;
                                p{
                                    font-size: $TextSize;
                                    color: #fff;
                                }
                            }
                        }
                        .Type{
                            div{
                                width: 0.4rem;
                                height: 0.15rem;
                                border-radius: 0.2rem;
                                p{
                                    font-size: $TextSize;
                                    color: #fff;
                                }
                            }
                        }
                    }
                    .Time{
                        position: absolute;
                        right: 0.1rem;
                        top: 0.1rem;
                        .Top{
                            margin-bottom: 0.05rem;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                opacity: 0.7;
                                margin-left: 0.1rem;
                                float: right;
                            }
                        }
                        .Bottom{
                            margin-right: 0;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                opacity: 0.7;
                                margin-left: 0.1rem;
                                float: right;
                            }
                        }
                    }
                    .Name{
                        padding: 0.1rem 0 0 0.1rem;
                        p:first-child{
                            font-size: $AdditionTextSize;
                            color: #fff;
                            opacity: 0.7;
                            margin-bottom: 0.05rem;
                        }
                        p:last-child{
                            font-size: $TitleSize;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>
